import type { Permission } from '@ztechapps/common.contract'

export const driverPermissions = {
  // Granted programmatically when a driver self-registers (RegisterNewDriver action, and the
  // mobile /register route in HaulerRouter) — never offered as a checkbox on the permission
  // grant screen, so it is intentionally left out of haulerPermissionCatalog.
  isDriver: {
    value: 'Driver',
    label: 'Is Driver',
    description: 'Marks the user as a driver. Granted automatically at driver registration, not through the permission grant screen.',
  } satisfies Permission,

  canView: {
    value: 'driver.canView',
    label: 'Can View',
    description: 'No modification can be done to the driver, only viewing of details.',
  } satisfies Permission,

  canEdit: {
    value: 'driver.canEdit',
    label: 'Can Edit',
    description: 'Can modify the records for all fields of driver',
  } satisfies Permission,

  canDelete: {
    value: 'driver.canDelete',
    label: 'Can Delete',
    description: 'Can delete the records for all fields of driver. This will delete entire record and cannot be recovered.',
  } satisfies Permission,
}
